module.exports = __webpack_public_path__ + "img/1.7cde0275.png";